<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">
            海上航空運賃登録・フレイト I/V作成 （{{
              form.isFreightConfirm === true ? "確認済み" : "未確認"
            }}）
          </div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="copyAs" v-permit.SHARP_FD_CLONE v-show="form.id != null"
          >参照新規作成</v-btn
        >
        <v-btn
          :disabled="!formValid || !loadValid"
          @click="save"
          v-if="form.id == null"
          v-permit.SHARP_FD_IV_SAVE
          >保存</v-btn
        >
        <v-btn @click="back">{{ $t("app.buttons.back") }}</v-btn>
        <!-- <v-btn color="success" v-permit.SHARP_FD_REDIRECT_NEW>新規作成</v-btn> -->

        <v-btn
          :disabled="form.id == null || isPartnerSa || isDapDdp"
          @click="exportInvoice"
          v-permit.SHARP_FD_IV_DOWNLOAD
          >フレイト I/V 出力</v-btn
        >

        <v-btn
          :disabled="!valid || form.isFreightConfirm || isPartnerSa"
          @click="chargeGeneration2(false)"
          v-permit.SHARP_FD_CALCULATION
          v-show="form.id != null"
          >海上・航空運賃計算</v-btn
        >
        <v-btn
          :disabled="!valid || form.isFreightConfirm || isPartnerSa"
          @click="chargeGeneration2(true)"
          v-permit.SHARP_FD_CALCULATION
          v-show="form.id != null"
          >海上・航空0運賃計算</v-btn
        >
        <v-btn
          :disabled="
            form.isFreightConfirm ||
            form.source == 'B1000' ||
            isPartnerSa ||
            !autoCalculatorVaild ||
            !handInValid
          "
          @click="freightConfirm"
          v-permit.SHARP_FREIGHT_INV_FEE_CONFIRM
          v-show="form.id != null"
          >フレイト確認</v-btn
        >
        <v-btn
          :disabled="form.isFreightConfirm === null || !form.isFreightConfirm"
          @click="freightConfirmCancel"
          v-permit.SHARP_FREIGHT_INV_FEE_CONFIRM_CANCEL
          v-show="form.id != null"
          >フレイト確認取消</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-card-text>
        <v-form v-model="valid">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex
                :key="index"
                md3
                sm6
                v-for="(item, index) in displayItems"
                v-if="!item.hasCondition || item.condition"
                xs12
              >
                <remote-autocomplete
                  :disabled="formReadOnly"
                  :label="item.label"
                  :rules="requiredRules(item)"
                  :url="item.url"
                  v-if="item.type === 'autocomplete'"
                  v-model="form[item.field]"
                />
                <remote-autocomplete
                  :disabled="formReadOnly"
                  :key="`4${form.transportModeId}`"
                  :label="item.label"
                  :rules="requiredRules(item)"
                  :url="
                    item.url +
                    '?careTransportMode=true&&transportModeId=' +
                    form.transportModeId
                  "
                  v-if="item.type === 'incoterm'"
                  v-model="form[item.field]"
                />
                <v-text-field
                  :disabled="formReadOnly"
                  :label="item.label"
                  :rules="requiredRules(item)"
                  v-if="item.type === 'text'"
                  v-model="form[item.field]"
                ></v-text-field>
                <v-text-field
                  :disabled="formReadOnly"
                  :label="item.label"
                  :rules="requiredRules(item)"
                  v-if="item.type === 'number'"
                  v-model.number="form[item.field]"
                ></v-text-field>
                <v-text-field
                  :disabled="formReadOnly"
                  :label="item.label"
                  :rules="requiredRules(item)"
                  @change="clearNum"
                  v-if="item.type === 'numberDouble'"
                  v-model="form[item.field]"
                ></v-text-field>
                <date-picker
                  :disabled="formReadOnly"
                  :label="item.label"
                  :rules="requiredRules(item)"
                  v-if="item.type === 'date'"
                  v-model="form[item.field]"
                ></date-picker>
                <remote-select
                  :disabled="formReadOnly"
                  :label="item.label"
                  :rules="requiredRules(item)"
                  :url="item.url"
                  v-if="item.type === 'select'"
                  v-model="form[item.field]"
                />
                <remote-select
                  :label="item.label"
                  :rules="requiredRules(item)"
                  :url="item.url"
                  v-if="item.type === 'editSelect'"
                  v-model="form[item.field]"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card class="mt-2" v-if="formReadOnly">
      <v-card-title primary-title>
        <div>B/L 情報</div>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md3 sm6 xs12>
                <v-text-field
                  :readonly="true"
                  :value="form.totalGW"
                  label="計算重量"
                ></v-text-field>
              </v-flex>
              <v-flex md3 sm6 xs12>
                <v-text-field
                  :readonly="true"
                  :value="totalPrice"
                  label="商品代金JPY"
                ></v-text-field>
              </v-flex>
              <v-flex md3 sm6 xs12>
                <v-text-field
                  :readonly="true"
                  :value="totalInsurancePrice"
                  label="保险费JPY"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <v-card-title>
        <span class="headline">フレイト詳細（自動計算）</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="autoCalculatorVaild">
          <v-card class="mt-2">
            <v-card-title>
              <v-layout row wrap>
                <v-flex sm-4>請求費用詳細</v-flex>
                <v-flex sm-6 style="text-align: right; color: #c03"
                  >支払調整金額はマイナス金額入力のみで、かつ調整後金額は≧0</v-flex
                >
              </v-layout>
            </v-card-title>

            <v-card-text>
              <list-total-charges
                :hideAdditionalCharges="true"
                :canAdjust="canAdjust"
                :shipment="form"
                class="mt-2"
                :columns="chargeColumns"
                :columnHeaders="{ 0: '計算費用項目', 1: '外貨小計', 5: '円価' }"
                ignoreSupplier
                ref="requestArea"
                scope="0"
              />
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <v-card-title>
        <span class="headline">フレイト詳細（ハンド入力）</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="handInValid">
          <edit-charges
            :exchangeRateDate="form.blIssueDate"
            ref="handArea"
            :shipment="form"
            :taxDate="new Date().format('yyyy-MM-dd')"
            :columns="handInColumns"
            exchangeRateScope="TTS"
            scope="0"
            taxDateType="freightCalc"
            v-if="this.$route.path.indexOf('new') === -1"
          />
        </v-form>
      </v-card-text>
    </v-card>
    <document-dialog ref="docDlg" />
    <document-dialog-swt ref="docDlgSwt" />
  </v-container>
</template>

<script>
import DocumentDialog from "./DocumentDialog";
import DocumentDialogSwt from "./DocumentDialogSWT";
export default {
  components: { DocumentDialog, DocumentDialogSwt },
  methods: {
    canAdjust(charge) {
      return !this.form.isFreightConfirm;
    },
    chargeGeneration() {},
    chargeGeneration2(isInternationalFreightZero) {},
    freightConfirm() {},
    freightConfirmCancel() {},
    copyAs() {},
    clearNum() {
      if (this.form.actualCw) {
        this.form.actualCw = this.$numberScale2(this.form.actualCw);
      }
      if (this.form.actualGw) {
        this.form.actualGw = this.$numberScale2(this.form.actualGw);
      }
      if (this.form.actualNw) {
        this.form.actualNw = this.$numberScale2(this.form.actualNw);
      }
      if (this.form.actualM3) {
        this.form.actualM3 = this.$numberScale3(this.form.actualM3);
      }
    },
    save() {
      this.$http
        .post(`/shipping-advices?view=B1001`, this.form)
        .then((res) => {
          this.$message("", this.$t("app.messages.saveSuccess"));
          this.$router.push({
            path: "/B1001/edit",
            query: { id: res.data.id },
          });
        })
        .catch((res) => this.$catch(res));
    },
    requiredRules(item) {
      return item.required ? [(v) => !!v || item.label + " is required"] : [];
    },
    back() {
      let value = localStorage.getItem("sourceB1000Id");
      if (value != null && this.form.id != value) {
        console.log("a");
        this.$router.push({
          name: "B1001Edit",
          query: { id: value },
        });
        this.load();
      } else {
        console.log("b");
        this.$router.push({
          path: "/B1000",
        });
      }
      // this.$router.go(-1)
    },
    exportInvoice() {
      if (this.isWarehouseTransport && this.isFCL) {
        this.$refs.docDlgSwt.popup([this.form]);
      } else {
        this.$refs.docDlg.popup([this.form]);
      }
    },
  },
  computed: {
    forwarderUrl() {
      return this.form.hasAnyChildConfirmed
        ? "companies/kv-include-all"
        : "companies/forwarders/kv";
    },
    customsUrl() {
      return this.form.hasAnyChildConfirmed
        ? "companies/kv-include-all"
        : "companies/customs/kv";
    },
    chargeColumns() {
      if (this.isDapDdp) {
        return "0,13,2,4,14,1,5,6,7,9,10,11,12";
      }
      return "0,13,2,4,14,1,5,6,7,9,10,11";
    },
    autoCalculatorColumns() {
      let columns = "18,13,2,3,14,15,19";
      if (this.isDapDdp) {
        columns += ",23";
      }
      return columns;
    },
    handInColumns() {
      let columns = "12,1,5,2,3,13,10,11";
      if (this.isDapDdp) {
        columns += ",24";
      }
      return columns;
    },
    formItems() {
      return [
        { label: "B/L NO", field: "blNo", type: "text", required: true },
        {
          label: "海外取引先",
          field: "partnerId",
          type: "autocomplete",
          required: true,
          url: "companies/kv?type=PARTNER",
        },
        {
          label: "B/L発行日",
          field: "blIssueDate",
          type: "date",
          required: true,
        },
        { type: "space" },
        {
          label: "積出港",
          field: "loadingPortCode",
          type: "autocomplete",
          required: true,
          url: "ports/kv",
        },
        {
          label: "陸揚港",
          field: "dischargePortCode",
          type: "autocomplete",
          required: true,
          url: "ports/kv",
        },
        { label: "ETD", field: "etd", type: "date", required: true },
        { label: "ETA", field: "eta", type: "date", required: true },
        { label: "本船名", field: "shipName", type: "text" },
        {
          label: "船社・航空会社",
          field: "forwarderId",
          type: "autocomplete",
          required: true,
          url: this.forwarderUrl,
        },
        {
          label: "貨物タイプ",
          field: "commodityTypeId",
          type: "editSelect",
          required: true,
          url: "commodity-types/kv",
        },
        {
          label: "Special",
          field: "specialId",
          type: "editSelect",
          required: true,
          url: "specials/kv",
        },
        {
          label: "納入場所",
          field: "finallyWarehouseId",
          type: "editSelect",
          required: true,
          hasCondition: true,
          condition: this.isWarehouseTransport,
          url: "warehouses/sjl-kv",
        },
        {
          label: "通関業者",
          field: "customsDirectorId",
          type: "autocomplete",
          required: true,
          hasCondition: true,
          condition: !this.isWarehouseTransport,
          url: this.customsUrl,
        },
        {
          label: "輸送形態",
          field: "transportModeId",
          type: "select",
          required: true,
          url: "transport-modes/kv",
        },
        {
          label: "建值",
          field: "incotermId",
          type: "autocomplete",
          required: true,
          url: "incoterms/kv/codes",
        },
        {
          label: "積み方",
          field: "stackTypeId",
          type: "select",
          required: true,
          url: "stack-types/kv?code=FCL",
        },
        {
          label: "通貨",
          field: "currencyCode",
          type: "autocomplete",
          required: true,
          url: "currencies/kv",
        },
        { label: "C/W", field: "actualCw", type: "numberDouble" },
        { label: "G/W", field: "actualGw", type: "numberDouble" },
        { label: "N/W", field: "actualNw", type: "numberDouble" },
        { label: "M3", field: "actualM3", type: "numberDouble" },
        {
          label: "コンテナ20F-本数",
          field: "containerNumber20F",
          type: "number",
        },
        {
          label: "コンテナ40F-本数",
          field: "containerNumber40F",
          type: "number",
        },
        {
          label: "コンテナ40H-本数",
          field: "containerNumber40H",
          type: "number",
        },
      ];
    },
    isFCL() {
      return (
        this.form.stackTypeId && this.form.stackTypeId.indexOf("-FCL") !== -1
      );
    },
    isAir() {
      return (
        this.form.transportModeId &&
        this.form.transportModeId.indexOf("-AIR") !== -1
      );
    },
    isWarehouseTransport() {
      return (
        (this.isFCL || this.isAir) &&
        this.form.isAllUnpaid &&
        this.form.specialId &&
        this.form.specialId.indexOf("WAREHOUSE_TRANSPORT") !== -1
      );
    },
    isPartnerSa() {
      return this.form.shipmentType === "PARTNERSA";
    },
    isDapDdp() {
      return "INCOTERM-DAP,INCOTERM-DDP".indexOf(this.form.incotermId) !== -1;
    },
    totalPrice() {
      return null;
    },
    formReadOnly() {
      return false;
    },
    formValid() {
      return this.valid;
    },
    displayItems() {
      return this.$isSea(this.form.transportModeId)
        ? this.formItems.filter((i) => !this.seaExcludeFields.includes(i.field))
        : this.formItems.filter(
            (i) => !this.airExcludeFields.includes(i.field)
          );
    },
    seaExcludeFields() {
      if (this.$route.path.indexOf("new") > -1 || this.form.source == "B1000") {
        return this.fieldGroup1;
      }
      return [...this.fieldGroup1, ...this.fieldGroup2];
    },
    airExcludeFields() {
      return [...this.fieldGroup2, ...this.fieldGroup3];
    },
  },
  mounted() {
    this.form = this.$route.params.shipment || this.form;
  },
  data() {
    return {
      handInValid: false,
      autoCalculatorVaild: false,
      fieldGroup1: ["actualCw", "actualGw", "actualNw", "actualM3"],
      fieldGroup2: [
        "containerNumber20F",
        "containerNumber40F",
        "containerNumber40H",
      ],
      fieldGroup3: ["stackTypeId"],
      selected: [],
      valid: false,
      form: {
        transportModeId: null,
      },
      loadValid: true,
    };
  },
};
</script>